import { initReactI18next } from "react-i18next";

import i18n from "i18next";

import translationFR from "./fr/translation.json";

const resources = {
  fr: {
    translation: translationFR,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "fr",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
